const STORAGE_KEY = "prompt-market-toss-pending-v1"

export type PendingTossOrder = {
  orderId: string
  amount: number
  promptIds: string[]
}

export function savePendingTossOrder(order: PendingTossOrder): void {
  if (typeof window === "undefined") return
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(order))
}

export function readPendingTossOrder(): PendingTossOrder | null {
  if (typeof window === "undefined") return null
  const raw = sessionStorage.getItem(STORAGE_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as PendingTossOrder
    if (
      typeof parsed.orderId === "string" &&
      typeof parsed.amount === "number" &&
      Array.isArray(parsed.promptIds) &&
      parsed.promptIds.every((id) => typeof id === "string")
    ) {
      return parsed
    }
  } catch {
    /* ignore */
  }
  return null
}

export function clearPendingTossOrder(): void {
  if (typeof window === "undefined") return
  sessionStorage.removeItem(STORAGE_KEY)
}
